import React from 'react';

const LOADER = <div className='loader' />;
const CLASS = {
  LOADER,
};
export default CLASS;
